import { ExamModal } from './ExamModal';
export default ExamModal;
